import {CriteriaEditorWidget} from "../list/CriteriaEditorWidget";
import * as OwnerType from "../../constants/OwnerType";
import * as PreferencesRequest from "../../constants/PreferencesRequest";
import {fetchPreferences} from "../../common/Metadata";
import {isEmptyOrNull} from "../../common/NamaCommon";
import * as CommonConstants from "../../constants/CommonConstants";
import * as ts from "../../common/Translator";
import {BaseWidget} from "../../widgets/BaseWidget";
import * as ExpressionRelationship from "../../constants/ExpressionRelationship";

export class FlatDTOCriteriaEditor extends BaseWidget {
    constructor(block, presenter, ownerTypeField) {
        super({owner: presenter, id: block.fieldId});
        let that = this;
        that.block = block;
        that.ownerTypeField = ownerTypeField;
    }

    render() {
        let that = this;
        let presenter = that.owner;
        let fieldsWithId = presenter.getFieldsWithId(that.ownerTypeField);
        if (!fieldsWithId)
            return;
        that.forTypeField = fieldsWithId[0];
        if (!that.forTypeField.dropDown)
            return;
        that.forTypeField.criteriaEditorBlock = that;
        that.rootElement = $(`<div class="w-100"><div class="criteriaRoot">
                                    <div class="row w-100 mx-auto mb-1 align-items-center pt-1 ">
                                    </div>
                                    <div id="listScreenFiltering" style="margin-left: 10px">
                                        <div id="conditionsGroup"></div>
                                    </div>
                                </div></div>`);
        return that.rootElement;

    }

    approvalEntityChanged(entityType, oldCriteria) {
        let that = this;
        that.rootElement.find(".criteriaExpressionPart").remove();
        if (isEmptyOrNull(entityType))
            return;
        let req = {};
        req.owner = {ownerType: OwnerType.Entity, ownerId: entityType};
        req.properties = [PreferencesRequest.META_DATA];
        fetchPreferences(req, (preferences) => {
            let metaData = preferences.metaData;
            that.criteriaWidget = new CriteriaEditorWidget({
                rootElement: that.rootElement,
                presenter: that.owner,
                oldCriteria: oldCriteria,
                metadata: metaData,
                entityType: entityType,
                criteriaFields: createCriteriaFieldsFromMetadata(metaData, entityType),
                owner: that
            });
            try {
                let conditionsGroup = that.rootElement.find("#conditionsGroup");
                let btnsData = conditionsGroup.data("kendoButtonGroup");
                if (!btnsData) {
                    conditionsGroup.kendoButtonGroup({
                        items: [
                            {text: ts.translateId("AllConditions")},
                            {text: ts.translateId("AnyCondition")}

                        ],
                        select: function (e) {
                            that.updateCriteriaEditorVal();
                        }
                    });
                }
                btnsData = conditionsGroup.data("kendoButtonGroup");
                if (oldCriteria.expressions && oldCriteria.expressions.length) {
                    let relation = oldCriteria.expressions[0].relation;
                    if (relation == ExpressionRelationship.AND) {
                        btnsData.select(0);
                    } else {
                        btnsData.select(1);
                    }
                } else {
                    btnsData.select(0);
                }
                that.renderingWidget = true;
                that.criteriaWidget.render();
                that.renderingWidget = false;
                that.rootElement.find("#listScreenFilteringConditions").css({display: ""});
            } catch (e) {
                console.log(e);
                that.rootElement.find(".criteriaRoot").remove();
            }
        });
    }

    criteriaWidget_()
    {
        return this.criteriaWidget;
    }

    updateCriteriaEditorVal() {
        let that = this;
        if (that.renderingWidget)
            return;
        that.onEdit(that.readValueFromElement())
    }

    readValueFromElement() {
        return this.criteriaWidget.calcCriteria();
    }

    setValueInElement(value) {
        if (!value)
            return;
        let ownerType = value.ownerType || this.forTypeField.readValueFromElement();
        this.approvalEntityChanged(ownerType, value);
    }
}

function createCriteriaFieldsFromMetadata(metaData, ownerId) {
    let criteriaFields = [];

    for (let fieldMetadata of metaData.fieldsMetaData) {
        if (CommonConstants.IGNORED_FIELDS.binarySearch(fieldMetadata.fieldId) >= 0)
            continue;
        let id = ownerId + "." + fieldMetadata.fieldId;
        if (ts.translateId(id) === id)
            continue;
        criteriaFields.push({id: fieldMetadata.fieldId, metaData: fieldMetadata});
    }
    return criteriaFields;
}